import { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Col } from 'rsuite';
import { useNavigate, useParams } from 'react-router-dom';
import { DropdownStyled, Wrapper } from './listing_profile_page.styled';
import ListingDetailsView from './screens/listing_info_screen';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import Spinner from '../../components/spinner';
import {
  LISTING_STATUS_COLORS,
  LISTING_STATUS_TYPES,
} from '../../config/constants';
import { backArrowIcon_path } from '../../assets/index';
import Nav from './components/listing_info_header';
import { Listing, ListingVersion } from '../../data/types/listings';
import { formateServerDateToLocaleDate } from '../../utils/functions/time_date_functions';
import { Button } from '@nextui-org/react';
import { ListingActionButtons } from './components/action_buttons';

export default function ListingDetails({
  ListingsRepository,
  categoriesRepository,
  dataEditingRepository,
  store_id,
  actionUpdateListingStockAndPrice,
  categoryNamesMap,
}: {
  ListingsRepository: any;
  categoriesRepository?: any;
  dataEditingRepository?: any;
  store_id?: number;
  actionUpdateListingStockAndPrice?: (payload: any) => {
    type: string;
    payload: any;
  };
  categoryNamesMap: { [key: number]: string };
}) {
  const { listingId } = useParams();
  const navigate = useNavigate();
  const [listing, setListing] = useState<Listing>();
  const [categoryName, setCategoryName] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('listing-details');
  const [versions, setVersions] = useState<ListingVersion[]>([]);
  const [isTemplate, setIsTemplate] = useState(false);

  useEffect(() => {
    if (!listingId) {
      navigate(-1);
    } else {
      getListing(parseInt(listingId));
    }
  }, [location, listingId]);

  useEffect(() => {
    if (
      listing !== undefined &&
      listing.category_id !== null &&
      categoryNamesMap !== undefined &&
      categoryNamesMap[listing.category_id as number] !== undefined
    ) {
      setCategoryName(categoryNamesMap[listing.category_id as number]);
    }
  }, [listing, listingId]);

  const getListing = async (listing_id: number) => {
    setLoading(true);
    let listingItem;
    if (store_id) {
      listingItem = await ListingsRepository.getListingWithID(
        store_id,
        listing_id,
      );
    } else {
      listingItem = await ListingsRepository.getListingWithID(listing_id);
      if (!listingItem) {
        listingItem = await ListingsRepository.getTemplateWithID(listing_id);
        setIsTemplate(true);
      }
    }
    if (!listingItem) {
      navigate(-1);
      return;
    }
    setListing(listingItem);
    if (
      listingItem?.next_versions?.length ||
      listingItem.previouse_versions?.length
    ) {
      const combinedVersions = [
        ...(listingItem.next_versions || []),
        ...(listingItem.previouse_versions || []),
      ];
      // Create a Set of unique ListingVersion objects based on their 'id'
      const uniqueVersionsSet = new Set(
        combinedVersions.map((version) => version.id),
      );

      // Convert the Set back to an array
      const uniqueVersionsList = Array.from(uniqueVersionsSet)
        .map((id) => combinedVersions.find((version) => version.id === id))
        .filter((version) => version !== undefined); // Filter out undefined values

      setVersions(
        uniqueVersionsList
          .sort(
            (a: ListingVersion, b: ListingVersion) =>
              new Date(b.date_created).getTime() -
              new Date(a.date_created).getTime(),
          )
          .map((version) => version as ListingVersion),
      );
    }
    setLoading(false);
  };

  const getListingVersion = (listingVersion: ListingVersion) => {
    return (
      <span className="m-2 p-1">
        Revision at {formateServerDateToLocaleDate(listingVersion.date_created)}
        <span
          className={`text-white p-2 rounded`}
          style={{
            marginLeft: '5px',
            backgroundColor:
              LISTING_STATUS_COLORS[
                listingVersion.listing_status_num as keyof typeof LISTING_STATUS_COLORS
              ],
          }}
        >
          {
            LISTING_STATUS_TYPES[
              listingVersion.listing_status_num as keyof typeof LISTING_STATUS_TYPES
            ]
          }
        </span>
      </span>
    );
  };
  return (
    <Wrapper>
      {!loading && listing !== undefined ? (
        <div className="listing_page">
          <Row>
            <Col md={12}>
              <Nav activeTab={activeTab} setActiveTab={setActiveTab} />
            </Col>
          </Row>
          <Row
            style={{
              marginLeft: '5px',
            }}
          >
            <Col md={8} className="left-heading">
              <div className="d-flex" onClick={() => navigate(-1)}>
                <img
                  src={backArrowIcon_path}
                  alt="back"
                  style={{ paddingRight: '5px', cursor: 'pointer' }}
                />
                <h4 className="heading">
                  {isTemplate ? 'Template' : 'Listing'} {listingId} Info
                </h4>
              </div>
              <p className="mini-title">
                Variations: {listing?.items?.length} || Request ID: #
                {listing?.request?.id}
                <br /> Submitted By: {listing?.created_by_user_id} || Submitted
                On: {formateServerDateToLocaleDate(listing?.date_created)}
              </p>
            </Col>
            <Col md={8} className="right-heading">
              <div className="listing-actions">
                <div className="select_status">
                  {versions.length > 0 && (
                    <DropdownStyled className="ms-auto">
                      <Dropdown className="dropdown-container">
                        <Dropdown.Toggle
                          bsPrefix={'chevron-down border-0 bg-white'}
                        >
                          <span className="me-3">
                            {getListingVersion(versions[0])}
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {versions
                            .sort(
                              (a: ListingVersion, b: ListingVersion) =>
                                new Date(b.date_created).getTime() -
                                new Date(a.date_created).getTime(),
                            )
                            .map((version) => {
                              return (
                                <Dropdown.Item
                                  key={version.id}
                                  onClick={() => getListing(version.id)}
                                >
                                  {getListingVersion(version)}
                                </Dropdown.Item>
                              );
                            })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </DropdownStyled>
                  )}
                </div>
                <ListingActionButtons
                  showDeleteButton={store_id !== undefined}
                  showHideButton={true}
                  showDetailsButton={false}
                  listing={listing}
                  ListingsRepository={ListingsRepository}
                  store_id={store_id}
                  onHideListingSuccess={(listingId: number) => {
                    getListing(listingId);
                  }}
                />

                {!store_id && (
                  <Button
                    onClick={() => {
                      navigate('/templates/new', {
                        state: { row: listing, duplicate: true },
                      });
                    }}
                    color={'success'}
                    variant="flat"
                  >
                    Duplicate Template
                  </Button>
                )}
                <Button
                  onClick={() => {
                    if (!store_id || isTemplate) {
                      navigate('/templates/new', {
                        state: { row: listing, duplicate: false },
                      });
                    } else {
                      navigate('/create-new-item', {
                        state: {
                          ...listing,
                          edit: true,
                        },
                      });
                    }
                  }}
                  isDisabled={listing?.new_listing_version_id !== null}
                  color={
                    listing?.new_listing_version_id === null
                      ? 'success'
                      : 'secondary'
                  }
                >
                  {listing?.new_listing_version_id === null
                    ? 'Create New Version'
                    : 'Select Newer Version'}
                </Button>
              </div>
            </Col>
          </Row>

          {/* Listing View */}
          <Row>
            <ListingDetailsView
              listingDetails={listing!}
              categoriesRepository={categoriesRepository}
              actionUpdateListingStockAndPrice={
                actionUpdateListingStockAndPrice
              }
              categoryName={categoryName}
              dataEditingRepository={dataEditingRepository}
            />
          </Row>
        </div>
      ) : (
        <div className="m-5">
          <Spinner />
        </div>
      )}
    </Wrapper>
  );
}
